import { MouseEvent } from 'react'
import ContextMenuBaseItem from './ContextMenuBaseItem'
import { MenuList, MenuItem } from '@carto/meridian-ds/components'
import { ContextMenuBaseProps, ContextMenuItem } from './interfaces'

export type ContextMenuPropsList = Pick<
  ContextMenuBaseProps,
  'onClickItem' | 'dense' | 'menuItems' | 'menuTitle' | 'selected' | 'extended'
>
export function ContextMenuList({
  menuItems,
  selected,
  onClickItem,
  menuTitle,
  dense,
  extended
}: ContextMenuPropsList) {
  const handleClickItem = (item: ContextMenuItem, e: MouseEvent) => {
    e.stopPropagation()
    onClickItem(item, e)
    return
  }

  return (
    <MenuList variant="menu" autoFocus autoFocusItem dense={dense}>
      {menuTitle && <MenuItem subtitle>{menuTitle}</MenuItem>}
      {menuItems
        .filter((c) => !c.hidden)
        .map((item, index) => (
          <ContextMenuBaseItem
            key={index}
            dense={dense}
            extended={extended}
            clickItem={handleClickItem}
            item={item}
            selected={selected}
          />
        ))}
    </MenuList>
  )
}
